import { styled } from "@mui/material";

const ContentBody = styled("div")(({ theme }) => ({
    margin: theme.spacing(2),
    width: 'auto',
    height: 'auto'
}));

export default ContentBody;